import { gql } from '@grandvisionhq/graphql';

const shoppinglistProductPricesFragment = gql`
  fragment ShoppinglistProductPricesFragment on ProductPrices {
    discountedPrice {
      price {
        amount
        currencyCode
      }
    }
    originalPrice {
      amount
      currencyCode
    }
  }
`;
const shoppinglistProductMediaFragment = gql`
  fragment ShoppinglistProductMediaFragment on Media {
    images {
      url
    }
  }
`;
const shoppinglistProductFragment = gql`
  fragment ShoppinglistProductFragment on Product {
    ... on AccessoriesProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on ContactLensProduct {
      slug
      productType
      productMasterKey
      variants {
        sku
        gan
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on FrameProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on LensTypeProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on PrescriptionGlassesPackageOptionsProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on PrescriptionGlassesPackageProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on ReadyReaderProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on SolutionProduct {
      slug
      productType
      variants {
        gan
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
    ... on SunglassesProduct {
      slug
      productType
      variants {
        sku
        prices {
          ...ShoppinglistProductPricesFragment
        }
        media {
          ...ShoppinglistProductMediaFragment
        }
      }
    }
  }
  ${shoppinglistProductMediaFragment}
  ${shoppinglistProductPricesFragment}
`;
const shoppinglistFragment = gql`
  fragment ShoppinglistFragment on Shoppinglist {
    id
    items {
      name
      sku
      product {
        ...ShoppinglistProductFragment
      }
    }
  }
  ${shoppinglistProductFragment}
`;

export { shoppinglistFragment };
//# sourceMappingURL=shopping-list.js.map
